<template>
  <div>
    <div class="row col-md-12">
      <div class="card card-siak">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            <h1>Rekap Nilai Siswa - CUMLAUDE</h1>
          </div>
        </div>
        <KTCodePreview>
          <template v-slot:preview>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="code4.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="code4.headers" :items="code4.desserts" :search="code4.search">
              </v-data-table>
            </v-card>
          </template>
          <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template>
        </KTCodePreview>

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      code4: {
        html: `<v-card>
  <v-card-title>
    Nutrition
    <v-spacer></v-spacer>
    <v-text-field
      v-model="search"
      append-icon="search"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
  </v-card-title>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
  ></v-data-table>
</v-card>`,
        js: ` export default {
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Dessert (100g serving)',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' },
      ],
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: '1%',
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: '1%',
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: '7%',
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: '8%',
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: '16%',
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: '0%',
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: '2%',
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: '45%',
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: '22%',
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: '6%',
        },
      ],
    }
  },
}`,
        search: "",
        headers: [
          {
            text: "No",
            value: "no"
          },
          { text: "NRP", value: "nrp" },
          { text: "Nama", value: "nama" },
          { text: "Prodi", value: "prodi" },
          { text: "Angkatan", value: "angkatan" },
          { text: "IPK", value: "ipk" }
        ],
        desserts: [
          {
            no: 1,
            nrp: 181814,
            nama: "Deddy Harlianto",
            prodi: "DIKREG",
            angkatan: 60,
            ipk: 3.99,
          },
          {
            no: 2,
            nrp: 181814,
            nama: "Muhammad Ilham",
            prodi: "DIKREG",
            angkatan: 60,
            ipk: 3.99,
          },
          {
            no: 3,
            nrp: 181814,
            nama: "Adhi Nugroho",
            prodi: "DIKREG",
            angkatan: 60,
            ipk: 3.99,
          },
          {
            no: 4,
            nrp: 181814,
            nama: "Hendra Siregar",
            prodi: "DIKREG",
            angkatan: 60,
            ipk: 3.99,
          },
          {
            no: 5,
            nrp: 181814,
            nama: "Rilmal Ridjal",
            prodi: "DIKREG",
            angkatan: 60,
            ipk: 3.99,
          }
        ]
      },
      options: [
        { text: "Area AKMIL", value: "1" },
        { text: "Luar AKMIL", value: "0" }
      ]
    };
  },
  components: {
    KTCodePreview
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Rekap", route: "rekapNilai" },
      { title: "Rekap Nilai Siswa" }
    ]);
  }
}
</script>